export const DEFAULT = 0;
export const COORDINATES_ZOOM = 14;
export const NON_COORDINATES_ZOOM = 2;

export const LAYERS = {
  OPEN_STREET_MAP: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
};
